import { render } from "./FullScreenAlert.vue?vue&type=template&id=3758b378&scoped=true"
import script from "./FullScreenAlert.vue?vue&type=script&lang=js"
export * from "./FullScreenAlert.vue?vue&type=script&lang=js"

import "./FullScreenAlert.vue?vue&type=style&index=0&id=3758b378&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3758b378"]])

export default __exports__